import { TenantUpdateSourceType } from '../types';

// Keep in sync with updateSourceLabels in packages/api/rest-api/tenants.js
const sourceLabels: Record<TenantUpdateSourceType, string> = {
    profile: 'Företagsprofil',
    metadata: 'Fordon, utrustning och certifikat',
    logo: 'Logotyp'
};

const sourceOrder: TenantUpdateSourceType[] = ['profile', 'metadata', 'logo'];

const sourceRank = (source: string) => {
    const index = sourceOrder.indexOf(source as TenantUpdateSourceType);
    return index === -1 ? sourceOrder.length : index;
};

// Labels are separated by a middot since they contain commas themselves
export default function formatTenantUpdateSources(sources?: string[] | null) {
    return [...(sources || [])]
        .sort((a, b) => sourceRank(a) - sourceRank(b))
        .map((source) => sourceLabels[source as TenantUpdateSourceType] || source)
        .join(' · ');
}
